import { useI18n } from 'vue-i18n'

export const errorMessageWithParams = (validation, fieldName) => {

  const { t } = useI18n()
  let messages = []

  const rules = Object.keys(validation ?? {}).filter(item => item.startsWith('$') === false)

  const items = rules.reduce((obj, key) => {
    obj[key] = validation[key]
    return obj
  }, {})

  for (const key in items) {
    if (items[key]?.$invalid === true && items[key]?.$pending === false) {
      const params = {
        ...items[key].$params,
        field: t(fieldName)
      }

      if (key === 'minLength') {
        params.min_length = params.min
      } else if (key === 'minValue') {
        params.min_value = params.min
      } else if (key === 'maxValue') {
        params.max_value = params.max
      } else if (key === 'maxLength') {
        params.max_length = params.max
      }

      let message = ''

      if (key === 'decimalPoint') {
        message = t('views.admin.tarfin_pro_stock_interest.decimal_number_error')
      }
      if (key === 'validNameValidator') {
        message = t(`shared.validations.valid_name_validator`)
      }

      if (key !== 'decimalPoint' && key !== 'validNameValidator') {
        message = t(`shared.validations.${key}`, params)
      }

      messages.push(message)
    }
  }

  if (messages.length === 0 && validation?.$errors?.length > 0) {
    validation?.$errors.forEach(error => {
      messages.push(error.$message)
    })
  }

  if (messages.length === 0) {
    messages.push(
      t('shared.validations.required', {
        field: t(fieldName)
      })
    )
  }

  return messages
}
